import type {
  Account,
  RestoreAccountConnectivityConfig,
} from '@repo/api-gw-sdk';

import type { Step } from '@/components/wizard/Step';

import { AwsRestoreAccountConfigVpcSelection } from './awsRestoreAccountConfigVpcSelection';
import { GcpRestoreAccountConfigVpcSelection } from './gcpRestoreAccountConfigVpcSelection';

export interface RestoreAccountConfigState {
  account: Account;
  config: RestoreAccountConnectivityConfig;
}

export const AwsRestoreAccountConfigFlow: Step<RestoreAccountConfigState> = {
  name: 'VPC Selection',
  Component: AwsRestoreAccountConfigVpcSelection,
  next: [],
};

export const GcpRestoreAccountConfigFlow: Step<RestoreAccountConfigState> = {
  name: 'Network Selection',
  Component: GcpRestoreAccountConfigVpcSelection,
  next: [],
};
